export const aboutUsOptions = [
  { value: 1, label: "Friend" },
  { value: 3, label: "Google" },
  { value: 2, label: "Web Search" },
  { value: 5, label: "Online Ad" },
  { value: 6, label: "Through Network" },
  { value: 8, label: "Direct Email" },
  { value: 7, label: "Clamour" },
  { value: 9, label: "Seattle YouTube Event" },
  { value: 10, label: "Ritual Network" },
  { value: 4, label: "MagicLinks' Team" },
  { value: 11, label: "Instagram Stories" },
  { value: 12, label: "MagicLinks Blog" },
  { value: 13, label: "Medium.com" },
  { value: 14, label: "Tubefilter" },
  { value: 15, label: "Facebook" },
  { value: 16, label: "TikTok" },
  { value: 17, label: "MagicLinks YouTube Channel" },
  { value: 18, label: "MagicLinks Facebook Page" },
  { value: 19, label: "MagicLinks Instagram" },
  { value: 20, label: "LinkedIn" },
  { value: 21, label: "MagicLinks TikTok" },
  { value: 22, label: "Community" },
];

export const booleanOptions = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];

export const creatorContactOptions = [
  {
    label: "Myself",
    value: "myself",
  },
  {
    label: "My manager",
    value: "manager",
  },
];
